import {
  applyMiddleware,
  combineReducers,
  legacy_createStore as createStore,
} from "redux";
import thunk from "redux-thunk";

import AuthReducer from "./reducers/authReducer";
import CategoryReducer from "./reducers/categoryReducer";
import RegistrationReducer from "./reducers/registrationReducer";
import ProductReducer from "./reducers/ProductReducer";
import ProfileReducer from "./reducers/profileReducer";
import VendorReducer from "./reducers/VendorReducer";
import POProductReducer from "./reducers/POProductReducer";
import OrderReducer from "./reducers/OrderReducer";
import HSNReducer from "./reducers/HSNReducer";
import CartReducer from "./reducers/CartReducer";
import TransactionReducer from "./reducers/TransactionReducer";
import GalleryReducer from "./reducers/GalleryReducer";
import DeliveryAreaReducer from "./reducers/DeliveryAreaReducer";
import PvReducer from "./reducers/PvReducer";
import POSReducer from "./reducers/POSReducer";

const rootReducer = combineReducers({
  category: CategoryReducer,
  product: ProductReducer,
  mangeRegistration: RegistrationReducer,
  auth: AuthReducer,
  profile: ProfileReducer,
  vendor: VendorReducer,
  po_product: POProductReducer,
  order: OrderReducer,
  hsn: HSNReducer,
  cart: CartReducer,
  transaction: TransactionReducer,
  gallery: GalleryReducer,
  deliveryArea: DeliveryAreaReducer,
  pv: PvReducer,
  pos: POSReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export type RootState = ReturnType<typeof rootReducer>;

export default store;
